import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Select } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';
import { EmployeeState } from 'src/app/employees/employees.state';
import { Employee } from 'src/app/models/Employee';

@Component({
    selector: 'app-dashboard-employee-work-anniversary-widget',
    templateUrl: './dashboard-employee-work-anniversary-widget.component.html',
    styleUrls: ['./dashboard-employee-work-anniversary-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DashboardEmployeeWorkAnniversaryWidgetComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(EmployeeState.WorkAnniversaryEmployees)
    workAnniversaryEmployees$: Observable<Employee[]>;
    noWorkAnniversaries = false;

    displayedColumns: string[] = ['firstName', 'age', 'daysUntilHired'];
    dataSource: MatTableDataSource<Employee> = new MatTableDataSource();
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    isLoading = true;

    constructor(private logger: NGXLogger) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.workAnniversaryEmployees$.subscribe(
                (employees) => {
                    if (employees && employees.length == 0) {
                        this.logger.debug('Retrieved 0 employees from the state');
                        this.noWorkAnniversaries = true;
                    } else if (employees && employees.length > 0) {
                        this.logger.debug('Retrieved employees from the state, filtering with work anniversary within 30 days');
                        this.dataSource.data = employees;
                        this.dataSource.sort = this.sort;
                        this.dataSource.sortingDataAccessor = (data, attribute) => data[attribute];
                    }
                    if (employees) {
                        this.isLoading = false;
                    }
                },
                () => {
                    this.logger.error('Failed to retrieve work-anniversary-employees');
                },
            ),
        );
    }

    /* Show years of employment or 'start' for newly recruited employees */
    getEmployeeHiredYears(employee: Employee) {
        const years = new Date().getFullYear() - new Date(employee.hireDate).getFullYear();
        return years == 0 ? 'Start' : years;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
